import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { getContainerStyles } from '@/utils';

export const useStyles = () => {
  const { theme } = useTheme();
  return useMemo(
    () => ({
      wrapper: css`
        width: 100%;
        overflow: hidden;
      `,
      container: css`
        ${getContainerStyles(theme)};
        ${responsive.create({
          paddingTop: {
            default: theme.spacing.get(48),
            md: theme.spacing.get(0),
            lg: theme.spacing.get(100),
          },
          paddingBottom: {
            default: theme.spacing.get(48),
            md: theme.spacing.get(72),
            lg: theme.spacing.get(100),
          },
        })}
      `,

      sectionTitle: css`
        color: var(--text-color);
        text-align: center;
        opacity: 0.9;
        ${responsive.create({
          fontSize: { default: '20px', md: '24px', lg: '32px' },
        })}
      `,

      logoItem: css`
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 auto;
        width: 100%;
        min-height: 64px;
        line-height: 0;

        img {
          display: block;
          height: auto;
          max-height: 64px;
        }

        @media (min-width: 768px) {
          width: auto;
          height: 64px;
        }
      `,
    }),
    [theme],
  );
};
